import React from 'react';

const CdMain = () => {
    return (
        <div>
            Cabdata
        </div>
    );
};

export default CdMain;